import firebase from './index'

export function firebaseFetchAllDealers() {
  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref()
      .child('dealers')
      .once('value')
      .then(snap => {
        resolve(snap.val())
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function firebaseFetchOneDealer(id) {
  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref()
      .child(`dealers`)
      .child(id)
      .once('value')
      .then(snap => {
        resolve(snap.val())
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function firebaseCreateDealer(newDealer) {
  return firebase
    .database()
    .ref()
    .child(`dealers`)
    .push()
    .set(newDealer)
}

export function firebaseUpdateDealer(dealerID, updates) {
  return firebase
    .database()
    .ref()
    .child(`dealers`)
    .child(dealerID)
    .update(updates)
}
